import { Controller } from '@hotwired/stimulus'

const ACTIVE_LINK_KEY = 'dois-elos:active-navigation-link'

export default class extends Controller {
  static targets = ['link']

  connect() {
    this.handleLocationChange = this.update.bind(this)
    window.addEventListener('hashchange', this.handleLocationChange)
    this.update()
  }

  disconnect() {
    window.removeEventListener('hashchange', this.handleLocationChange)
  }

  activate(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const clickedLink = event.target.closest('a')
    if (!clickedLink) return

    let link = clickedLink.matches('[data-app-navigation-target="link"]') ? clickedLink : null
    if (!link && clickedLink.matches('.home-brand')) {
      const brandUrl = new URL(clickedLink.href, window.location.href)
      link = this.linkTargets.find((element) => {
        const url = new URL(element.href, window.location.href)
        return !url.hash && url.pathname === brandUrl.pathname
      })
    }

    if (!link) return

    this.rememberActiveLink(link)
    this.setActiveLink(link)
  }

  update() {
    const currentUrl = new URL(window.location.href)
    const links = this.linkTargets.map((element) => ({
      element,
      url: new URL(element.href, currentUrl)
    }))

    const locationLink = links.find(({ url }) => (
      currentUrl.hash &&
      url.pathname === currentUrl.pathname &&
      url.hash === currentUrl.hash
    ))
    const rememberedLink = this.rememberedActiveLink(links, currentUrl)
    const pageLink = links.find(({ url }) => (
      !url.hash && url.pathname === currentUrl.pathname
    ))
    const renderedLink = links.find(({ element }) => element.classList.contains('is-active'))
    const activeLink = locationLink || rememberedLink || pageLink || renderedLink

    if (activeLink) this.rememberActiveLink(activeLink.element)
    this.setActiveLink(activeLink?.element)
  }

  rememberedActiveLink(links, currentUrl) {
    try {
      const href = window.sessionStorage.getItem(ACTIVE_LINK_KEY)
      if (!href) return

      const rememberedUrl = new URL(href, currentUrl)
      if (rememberedUrl.pathname !== currentUrl.pathname) return

      return links.find(({ url }) => (
        url.pathname === rememberedUrl.pathname && url.hash === rememberedUrl.hash
      ))
    } catch {
      return
    }
  }

  rememberActiveLink(link) {
    try {
      window.sessionStorage.setItem(ACTIVE_LINK_KEY, link.href)
    } catch {
      // Navigation still works when session storage is unavailable.
    }
  }

  setActiveLink(activeLink) {
    const activeHref = activeLink?.href

    this.linkTargets.forEach((element) => {
      const active = Boolean(activeHref && element.href === activeHref)
      element.classList.toggle('is-active', active)

      if (active) {
        element.setAttribute('aria-current', 'page')
      } else {
        element.removeAttribute('aria-current')
      }
    })
  }
}
